import { useEffect, useRef, useState } from 'react';

//Primereact components
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';

// Column
import { UserManagementListColumns } from '../../appconfig/DatatableSetting';

// Data table
import { defaultRowOptions, defaultPageRowOptions, paginatorLinks, showingEntries, Skeletonitems, SkeletonbodyTemplate } from '../../appconfig/Settings';

//Services
import { deleteData, getAllDetails, postAllData } from '../../service/ProductService';

import { Buffer } from 'buffer';
import { CREATE_USER, ROLE_LIST, USERLIST, DELETE_USER } from '../../config/ApiConstant';
import AppBreadcrumb from '../../components/CustomeBreadcrumb/AppBreadcrumb';
import { addUpdateUserValidate } from '../../config/Validate';

export const UserManagement = () => {
    document.title = 'User Management | GSPC';

    //Set Toast/ Filter Properties
    const toast = useRef<any>(null);
    const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);
    const [globalFilter, setGlobalFilter] = useState<any>(null);

    //Loading/Page Loading
    const [pageLoad, setPageLoad] = useState<boolean>(false);
    const [roleDropdown, setRoleDropdown] = useState<any>([]);
    const [userList, setUserList] = useState<any>([]);
    const [addUpdateModal, setAddUpdateModal] = useState<boolean>(false);
    const [addUpdateLoader, setAddUpdateLoader] = useState<boolean>(false);
    const [userDetails, setUserDetails] = useState<any>({});
    const [editId, setEditId] = useState<any>(null);
    const [deleteId, setDeleteId] = useState<any>(null);
    const [deleteModal, setDeleteModal] = useState<boolean>(false);
    const [deleteLoader, setDeleteLoader] = useState<boolean>(false);
    const [errors, setErrors] = useState<any>({});

    // useEffect
    useEffect(() => {
        getUserList();
        getRoles();

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    // Get all roles for dropdown
    const getRoles = async () => {
        try {
            const response = await getAllDetails(ROLE_LIST);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setRoleDropdown([]);
                } else {
                    let roleData = [];
                    for (let i = 0; i < DataList.length; i++) {
                        const roleObj: any = {};
                        if (DataList[i].name !== 'User') {
                            roleObj['name'] = DataList[i].name;
                            roleObj['code'] = DataList[i].id;
                            roleData.push(roleObj);
                        }
                    }
                    setRoleDropdown(roleData);
                }
            } else {
                setRoleDropdown([]);
            }
        } catch (error: any) {
            setRoleDropdown([]);
            toast.current?.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Sorry Could Not Load Data'
            });
        }
    };

    // Get user list api call
    const getUserList = async () => {
        try {
            setPageLoad(false);
            const response = await getAllDetails(USERLIST);
            if (response) {
                const DataList: any = response;
                if (DataList.length === 0) {
                    setUserList([]);
                } else {
                    setUserList(DataList);
                }
                setPageLoad(true);
            } else {
                setPageLoad(false);
                setUserList([]);
            }
        } catch (error: any) {
            if (error.response) {
                setPageLoad(false);
                setUserList([]);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Sorry Could Not Load Data'
                });
            }
        }
    };

    // Right toolbar
    const rightToolbarTemplate = () => {
        return (
            <>
                <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="p-button-outlined ml-2"></Button>
            </>
        );
    };

    // Global search
    const leftToolbarTemplate = () => {
        return (
            <>
                <span className="search-bar mr-3">
                    <i className="pi pi-search"></i>
                    <InputText type="search" className="search-input" onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
                </span>
                <Button label="Add User" icon="pi pi-plus" className="p-button mr-2" onClick={() => openAddModal()} />
            </>
        );
    };

    //Clear All Filter
    const clearAll = () => {
        setGlobalFieldFilter(null);
    };

    //On Input Change
    const onInputChange = (e: any, name: string) => {
        let val;
        if (name == 'role') {
            val = e;
        } else {
            val = (e.target && e.target.value) || '';
        }
        setUserDetails({ ...userDetails, [name]: val });
    };

    // Open add modal
    const openAddModal = () => {
        setAddUpdateModal(true);
    };

    // Open edit modal
    const openEditModal = (rowData: any) => {
        setEditId(rowData.id);
        setUserDetails({
            role: { name: rowData.user_type, code: rowData.role },
            first_name: rowData.full_name.split(' ')[0],
            sur_name: rowData.full_name.split(' ')[1],
            email: rowData.email,
            mobile: rowData.mobile
        });
        setAddUpdateModal(true);
    };

    // Close add update modal
    const closeAddUpdateModal = () => {
        setEditId(null);
        setUserDetails({});
        setAddUpdateLoader(false);
        setAddUpdateModal(false);
    };

    // On submit add edit
    const onSubmitAddEdit = async () => {
        try {
            const { errors, isError } = addUpdateUserValidate(userDetails, editId);
            setErrors(errors);

            //Check Error if no errors then call API
            if (!isError) {
                setAddUpdateLoader(true);

                //Request object
                let formData: any = new FormData();

                // Check editing is performed or not
                if (editId !== null) {
                    formData.append('id', editId);
                } else {
                    formData.append('email', userDetails.email);
                    let Bufpassword = Buffer.from(userDetails.password).toString('base64');
                    formData.append('password', Bufpassword);
                }

                formData.append('user_type', userDetails.role.name);
                formData.append('role', userDetails.role.code);
                formData.append('full_name', userDetails.first_name + ' ' + userDetails.sur_name);
                formData.append('mobile', userDetails.mobile);

                //apicall
                const response = await postAllData(CREATE_USER, formData);
                if (response && !window.cn(response)) {
                    setUserDetails({});
                    setEditId(null);
                    setAddUpdateLoader(false);
                    setAddUpdateModal(false);
                    toast.current?.show({ severity: 'success', summary: 'Success', detail: response?.message });
                    setTimeout(() => {
                        getUserList();
                    }, 1500);
                }
            }
        } catch (error: any) {
            if (error.response) {
                const backendErrors = error.response.data.errors;

                if (backendErrors) {
                    // Map backend errors to your state
                    const formattedErrors: any = {};

                    Object.keys(backendErrors).forEach((key) => {
                        formattedErrors[key] = backendErrors[key].join(' '); // Convert array messages into a single string
                    });
                    setErrors(formattedErrors);
                    setAddUpdateLoader(false);

                    toast.current?.show({
                        severity: 'error',
                        summary: 'Validation Error',
                        detail: 'Please fix the errors and try again.'
                    });
                } else {
                    //Spinner False and Set Toast

                    setAddUpdateLoader(false);
                    toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
                }
            }
        }
    };

    // Open delete modal
    const openDeleteModal = (id: any) => {
        setDeleteId(id);
        setDeleteModal(true);
    };

    // Close delete modal
    const closeDeleteModal = () => {
        setDeleteId(null);
        setDeleteLoader(false);
        setDeleteModal(false);
    };

    // On submit delete
    const onSubmitDelete = async () => {
        try {
            setDeleteLoader(true);
            // Delete api call
            const response = await deleteData(DELETE_USER, deleteId);
            if (response) {
                toast.current?.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: response?.message
                });
                setDeleteLoader(false);
                setDeleteModal(false);
                setDeleteId(null);
                getUserList();
                setPageLoad(true);
            } else {
                setPageLoad(false);
                toast.current?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Something went wrong, Please try again.'
                });
                setDeleteLoader(false);
            }
        } catch (error: any) {
            if (error.response) {
                //Spinner False and Set Toast
                setDeleteLoader(false);
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Something Went Wrong' });
            }
        }
    };

    // Template for actions
    const actionsTemplate = (rowData: any, rowIndex: any) => {
        return (
            <>
                <div className="actions action-btn">
                    <Button tooltip="Edit" tooltipOptions={{ position: 'top' }} icon="pi pi-pencil" onClick={() => openEditModal(rowData)} />
                    <Button tooltip="Delete" tooltipOptions={{ position: 'top' }} icon="pi pi-trash" onClick={() => openDeleteModal(rowData.id)} className="p-button-danger ml-2" />
                </div>
            </>
        );
    };

    return (
        <>
            <Toast ref={toast} />
            <AppBreadcrumb currentMenu={'User Management'} pageName={'User Management'} pageTitle={'User Management'} />
            <div className="grid crud-demo">
                <div className="col-12">
                    <div className="card">
                        <Toolbar left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                        {/* Datatable */}
                        {pageLoad ? (
                            <>
                                <DataTable
                                    value={userList}
                                    showGridlines
                                    stripedRows
                                    globalFilter={globalFilter}
                                    filters={globalFieldFilter}
                                    onFilter={(e) => setGlobalFieldFilter(e.filters)}
                                    rows={defaultRowOptions}
                                    paginator={userList.length >= 10 && true}
                                    rowsPerPageOptions={defaultPageRowOptions}
                                    className="datatable-responsive p-datatable-sm"
                                    paginatorTemplate={paginatorLinks}
                                    currentPageReportTemplate={showingEntries}
                                    emptyMessage="No Users Found"
                                >
                                    {UserManagementListColumns.map((col, i) => {
                                        if (col.field === 'action') {
                                            return <Column key={col.field} field={col.field} header={col.header} body={actionsTemplate} />;
                                        } else if (col.field === 'mobile') {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        } else if (col.field === 'user_type') {
                                            return <Column key={col.field} field={col.field} header={col.header} />;
                                        } else {
                                            return <Column key={col.field} field={col.field} header={col.header} sortable filter filterPlaceholder={'Search by ' + col.header} />;
                                        }
                                    })}
                                </DataTable>
                            </>
                        ) : (
                            <>
                                {/* Skeleton Data table */}
                                <DataTable value={Skeletonitems}>
                                    {UserManagementListColumns.map((col, i) => (
                                        <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                                    ))}
                                </DataTable>
                            </>
                        )}
                    </div>
                </div>
            </div>

            {/* Add Update Dialog */}
            <Dialog
                visible={addUpdateModal}
                className="p-fluid"
                style={{ width: '140vh' }}
                header={editId !== null ? 'Edit User' : 'Add User'}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeAddUpdateModal} />
                        <Button label="Submit" icon="pi pi-check" className="p-button-primary" onClick={() => onSubmitAddEdit()} loading={addUpdateLoader} />
                    </>
                }
                onHide={closeAddUpdateModal}
            >
                <div className="formgrid grid">
                    <div className="field col-6">
                        <label htmlFor="name">
                            First Name <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText value={userDetails?.first_name} name="first_name" autoComplete="off" placeholder="Enter First Name" onChange={(e) => onInputChange(e, 'first_name')} className={errors['first_name'] && 'p-invalid'} />
                        <small className="p-invalid-txt">{errors['first_name']}</small>
                    </div>
                    <div className="field col-6">
                        <label htmlFor="name">
                            Surname <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText value={userDetails?.sur_name} name="sur_name" autoComplete="off" placeholder="Enter Surname" onChange={(e) => onInputChange(e, 'sur_name')} className={errors['sur_name'] && 'p-invalid'} />
                        <small className="p-invalid-txt">{errors['sur_name']}</small>
                    </div>
                    <div className="field col-6">
                        <label htmlFor="name">
                            Email <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText
                            value={userDetails?.email}
                            name="email"
                            autoComplete="off"
                            placeholder="Enter Email"
                            onChange={(e) => onInputChange(e, 'email')}
                            className={errors['email'] && 'p-invalid'}
                            disabled={editId === null ? false : true}
                        />
                        <small className="p-invalid-txt">{errors['email']}</small>
                    </div>
                    <div className="field col-6">
                        <label htmlFor="name">
                            Role <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Dropdown value={userDetails?.role} name="role" options={roleDropdown} filter optionLabel="name" placeholder="Select Role" onChange={(e) => onInputChange(e.value, 'role')} className={errors['role'] && 'p-invalid'} />
                    </div>
                    {editId === null ? (
                        <>
                            <div className="field col-6">
                                <label htmlFor="name">
                                    Password <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText type="password" value={userDetails?.password} name="password" autoComplete="off" placeholder="Enter Password" onChange={(e) => onInputChange(e, 'password')} className={errors['password'] && 'p-invalid'} />
                                <small className="p-invalid-txt">{errors['password']}</small>
                            </div>
                            <div className="field col-6">
                                <label htmlFor="name">
                                    Confirm Password <span style={{ color: 'red' }}>*</span>
                                </label>
                                <InputText
                                    type="password"
                                    value={userDetails?.confirm_password}
                                    name="confirm_password"
                                    autoComplete="off"
                                    placeholder="Enter Confirm Password"
                                    onChange={(e) => onInputChange(e, 'confirm_password')}
                                    className={errors['confirm_password'] && 'p-invalid'}
                                />
                                <small className="p-invalid-txt">{errors['confirm_password']}</small>
                            </div>
                        </>
                    ) : (
                        <></>
                    )}
                    <div className="field col-6">
                        <label htmlFor="name">
                            Mobile Number <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText keyfilter="num" value={userDetails?.mobile} name="mobile" onChange={(e) => onInputChange(e, 'mobile')} id="mobile" className={errors['mobile'] && 'p-invalid'} autoComplete="off" />
                        <small className="p-invalid-txt">{errors['mobile']}</small>
                    </div>
                </div>
            </Dialog>

            {/* Delete Dialog */}
            <Dialog
                visible={deleteModal}
                style={{ width: '450px' }}
                header="Delete User"
                modal
                footer={
                    <>
                        <Button label="Cancel" icon="pi pi-times" className="p-button-secondary" onClick={closeDeleteModal} />
                        <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={onSubmitDelete} loading={deleteLoader} />
                    </>
                }
                onHide={closeDeleteModal}
            >
                <div className="flex align-items-center justify-content-start">
                    <i className="pi pi-exclamation-triangle mr-3 delete-triangle" style={{ fontSize: '2rem' }} />
                    <span className="delete-dialog-note">Note: Once you delete this user, This will be deleted permanently.</span>
                </div>
            </Dialog>
        </>
    );
};
